import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import axios from "axios";
import '@fortawesome/fontawesome-free/css/all.min.css';
// import "font-awesome/css/font-awesome.min.css";
// import "bootstrap-icons/font/bootstrap-icons.css";
// Layouts
import Masterwebpage from "./layouts/admin/Masterwebpage";
import Masterauthwebpage from "./layouts/authAdmin/Masterauthwebpage";
import MasterUserwebpage from "./layouts/user/MasterUserwebpage";

// Admin Components

import VerifyStaffSheet from "./components/admin/childComponents/verify/VerifyStaffSheet";
import VerifyStaffIDCard from "./components/admin/childComponents/verify/VerifyStaffIDCard";

import TestScript from "./components/admin/childComponents/verify/TestScript";

// Test/ Maintainance
import Test from "./utils/Test";

// Backend config
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
axios.defaults.baseURL = BACKEND_URL;
axios.defaults.withXSRFToken = true;
axios.defaults.withCredentials = true;
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

// Token injection
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem("auth_token");
  config.headers.Authorization = token ? `Bearer ${token}` : "";
  return config;
});

function App() {
  useEffect(() => {
    // Load main.js AFTER everything is mounted
    const script = document.createElement("script");
    script.src = "/assets/js/main.js"; // must be inside /public/assets/js
    script.async = false; // run in order
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <Routes>
      {/* Test Utility */}
      <Route path="/test" element={<Test />} />
      <Route path="/testscript" element={<TestScript />} />

      {/* PayStack */}
      <Route path="/paystackverify" element={<MasterUserwebpage name="PaystackVerify" />} />

      {/* Website Routes */}
      <Route path="/" element={<MasterUserwebpage name="HomePage" />} />
      <Route path="/:section/:id" element={<MasterUserwebpage name="HomePage" />} /> 
      <Route path="/:section/:id/album/:albumId" element={<MasterUserwebpage name="HomePage" />} /> 
      <Route path="/searches/:search" element={<MasterUserwebpage name="Search" />} />
      <Route path="/read/:reads" element={<MasterUserwebpage name="Read" />} />

      {/* Auth Section */}
      <Route path="/login" element={<Masterauthwebpage name="Login" />} />
      <Route path="/logout" element={<Masterauthwebpage name="Login" />} />
      <Route path="/register01" element={<Masterauthwebpage name="Register01" />} />
      <Route path="/register02" element={<Masterauthwebpage name="Register02" />} />
      <Route path="/register02/:otp" element={<Masterauthwebpage name="Register02b" />} />
      <Route path="/forgotpassword01" element={<Masterauthwebpage name="Forgotpassword01" />} />
      <Route path="/forgotpassword02" element={<Masterauthwebpage name="Forgotpassword02" />} />
      <Route path="/forgotpassword02/:otp" element={<Masterauthwebpage name="Forgotpassword02b" />} />

      {/* Verification Routes */}
      
      <Route path="/verifystaffsheet" element={<VerifyStaffSheet />} />
      <Route path="/verifystaffidcard" element={<VerifyStaffIDCard />} />
      

      {/* Admin Access */}
      <Route path="/1gps" element={<Masterwebpage name="GPS" />} />
      <Route path="/1crop" element={<Masterwebpage name="Crop" />} />
      <Route path="/1print" element={<Masterwebpage name="PrintDoc" />} />
      <Route path="/1pdf" element={<Masterwebpage name="Pdf" />} />
      <Route path="/1qrcodes" element={<Masterwebpage name="QrCodes" />} />
      <Route path="/1qrscanner" element={<Masterwebpage name="QrScanner" />} />
      <Route path="/1camera" element={<Masterwebpage name="Camera" />} />

      <Route path="/user/dashboard" element={<Masterwebpage name="Dashboard" />} />
      <Route path="/user/register" element={<Masterwebpage name="Register" />} />
      <Route path="/user/report" element={<Masterwebpage name="Report" />} />

      {/* 404 Page */}
      <Route path="/*" element={<MasterUserwebpage name="Page404" />} />
    </Routes>
  );
}

export default App;
